export const datamodelEntityListUrl = "datamodel/entities";
export const datamodelEnumerationListUrl = "datamodel/enumerations";
export const datamodelEventListUrl = "datamodel/events";
export const datamodelAlertListUrl = "datamodel/alerts";
export const datamodelCustomersListUrl = "datamodel/customers";

export const enumerationUrl = "datamodel/enumeration";
export const databaseConnectionUrl = "/datamodel/database-connection";
export const TransactionMonitoringSystemConfigUrl = "/datamodel/transaction-monitoring-system-config";
export const datamodelEntitiesNewUrl = "datamodel/entities/new";
export const datamodelEntityDetails= "datamodel/entities/:id";

export const datamodelAlertNewUrl = "datamodel/alerts/new";
export const datamodelAlertDetailsUrl = "datamodel/alerts/:id";

export const datamodelEventsNewUrl = "datamodel/events/new";
export const datamodelEventDetails= "datamodel/events/:id";
export const datamodelTokens= "tokens";
export const userListUrl = "/datamodel/users";


export function getDatamodelUrl(datamodelType: string): string | undefined {
  const urlMap: { [key: string]: string } = {
    entity: datamodelEntityDetails,
    event: datamodelEventDetails,
    alertcase: datamodelAlertDetailsUrl,
  };

  return urlMap[datamodelType];
}